var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVectorRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M12 0.5C8.62125 0.5 5.5775 1.86125 3.33125 4.04L2.6125 3.32125C1.925 2.635 0.75 3.12125 0.75 4.0925V8.72625C0.75 9.70625 1.54375 10.5 2.5225 10.5H7.15625C8.1275 10.5 8.615 9.325 7.9275 8.6375L6.85 7.55875C8.19375 6.28625 10.0025 5.5 12 5.5C16.1425 5.5 19.5 8.8575 19.5 13C19.5 17.1425 16.1425 20.5 12 20.5V25.5C18.9037 25.5 24.5 19.9037 24.5 13C24.5 6.09625 18.9037 0.5 12 0.5Z",
    fill: "#101AA1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorRefresh);
export default __webpack_public_path__ + "static/media/VectorRefresh.637a80f51632885c464f1e4c6c78c176.svg";
export { ForwardRef as ReactComponent };